// removed by extract-text-webpack-plugin
module.exports = {"header":"Header-header","monthYear":"Header-monthYear"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdatepicker/Header.scss
// module id = 362
// module chunks = 0